import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { Title } from 'src/app/shared/components/title/title.component';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class JsonConfiguration {
  titleData: Title;
  headerConfiguration: HeaderConfiguration;

  /**
   * Set initial configuration related data and i18n
   */
  constructor(private translateService: TranslateService) {
    this.setTitleData();
    this.setHeaderConfiguration();
    //this.setDynamicForm();
  }

  /**
   * Set title related data with i18n
   */
  private setTitleData(): void {
    this.titleData = {
      title: '',
    };

    this.translateService.get('contracts.title').subscribe((res) => {
      this.titleData.title = res;
    });
  }

  /**
   * Set header related data with i18n
   */
  private setHeaderConfiguration(): void {
    this.headerConfiguration = {
      layoutAlign: 'start start',
      sections: [
        {
          partner:true,
          menu:true,       
          // backButton: {
          //   styles: ['fs_4_underline'],
          //   route: '../calculator'
          // }
          // close: {
          // route: '../calculator'
          // }
        },
      ],
    };
  }
}
